<template>
  <div
    class="w-full rounded-[1.3rem] border border-gray-900/5 bg-gray-500/5 p-1.5"
  >
    <div
      class="w-full rounded-2xl border border-gray-900/5 shadow-[0_1px_1px_rgba(0,0,0,0.08)] overflow-hidden"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseOutline'
}
</script>

<style lang="scss" scoped></style>
